module.exports = __webpack_public_path__ + "static/media/20PerformancePhotos.c1c62169.jpeg";